import React from 'react';
import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next"; /* Added Line */

export default function ConfirmModal(props) {
    const [t, i18n] = useTranslation(); /* Added Line */
    return (
        <>
        <Modal
          className="modal fade"
          size={props.size || "md"}
          show={props.show}
          scrollable={!props.unscrollable}
          style={{overflow: 'visible'}}
        >
        <Modal.Header>
          <Modal.Title>{props.modalTitle}</Modal.Title>
          <Button 
              variant=""
              type="button"
              className="close"
              data-dismiss="modal"
              onClick={() => {
                if(props.closeModal){
                  props.closeModal();
                }
                props.setShowModal(false);
              }}>
            <span>×</span>
          </Button>
        </Modal.Header>
        <Modal.Body>
          <p>{props.modalBodyMessage}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button 
              variant="secondary"
              type="button"
              data-dismiss="modal"
              onClick={() => {
                if(props.closeModal){
                  props.closeModal();
                }
                props.setShowModal(false);
              }}>
            {t("modal.noButton")}
          </Button>
          <Button variant="primary" onClick={() => props.onYesButtonClicked(props.selectedRow)}>
          {t("modal.yesButton")}
          </Button>
        </Modal.Footer>
      </Modal>
        </>
    );
};
